module.exports = __webpack_public_path__ + "img/airport-shuttle.55748b64.svg";